import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { PageViewTracker as tracker } from 'src/explore/services/PageViewTracker';

export const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const trackLocation = {
      href: window.location.href,
      pathname: location.pathname,
      search: location.search,
    };

    tracker.track( trackLocation );
  }, [ location.pathname, location.search ]);

  return <></>;
}
